import React, { useState } from 'react';
import Toggle from 'components/toggle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { put } from 'helpers/api';
import Snackbar from 'shared/snackbar';
import Banner from 'shared/banner';

type DoNotGroupSpecialtiesToggleProps = {
  url: string;
  initialValue: boolean;
};

export default function GroupSpecialtiesToggle({ url, initialValue }: DoNotGroupSpecialtiesToggleProps) {
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [groupSpecialties, setGroupSpecialties] = useState(initialValue);
  const [errors, setErrors] = useState<string[]>([]);
  const [isSaving, setIsSaving] = useState(false);

  const tooltip = (
    <Tooltip id="do-not-group-specialties-tooltip">
      When enabled, specialties will be grouped together on the broker plugin by sale or lease.
    </Tooltip>
  );

  const toggleGroupSpecialties = async () => {
    setIsSaving(true);
    setErrors([]);

    try {
      await put(url, { group_specialties_on_broker_plugin: !groupSpecialties });
      setGroupSpecialties(!groupSpecialties);
      setShowSuccessSnackbar(true);
    } catch (error) {
      setErrors(error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="d-flex flex-column gap-3 mb-5">
      <Snackbar
        show={showSuccessSnackbar}
        text={`Updated to ${groupSpecialties ? '' : 'not '}group specialties on broker plugin`}
        variant="success"
        onClose={() => setShowSuccessSnackbar(false)}
      />
      <h3 className="m-0 d-inline-flex gap-2 align-items-center">
        Group specialties on the broker plugin by sale or lease
        <OverlayTrigger overlay={tooltip} placement="bottom">
          <FontAwesomeIcon icon={faQuestionCircle}/>
        </OverlayTrigger>
      </h3>
      {errors.length > 0 && (
        <Banner
          content={errors.join('\n')}
          show={errors.length > 0}
          title="The following errors occurred when trying to save. Please fix and re-submit."
          variant="danger"
          onClose={() => setErrors([])}
        />
      )}
      <div className="d-flex align-items-center gap-3">
        <Toggle checked={groupSpecialties} disabled={isSaving} theme="ds" onChange={toggleGroupSpecialties}/>
        <span>Group specialties on the broker plugin by sale or lease</span>
      </div>
    </div>
  );
}
